import { IColumnBannerProps } from '@root/components/ColumnBanner/models';
import Joi from 'joi';

const stringRequired = Joi.string().required();
const uriRequired = Joi.string().uri().required();
const imgSchema = {
  url: uriRequired,
  filename: Joi.string().required(),
};
const requiredImageSchema = Joi.object(imgSchema).required();

export const columnBannerSchema = Joi.object<IColumnBannerProps>({
  backgroundImage: requiredImageSchema,
  backgroundImageAlt: stringRequired,
  headlineLeft: stringRequired,
  headlineRight: stringRequired,
  descriptionLeft: stringRequired,
  descriptionRight: stringRequired,
  ctaLeftUrl: stringRequired,
  ctaRightUrl: stringRequired,
  ctaLeftLabel: stringRequired,
  ctaRightLabel: stringRequired,
}).options({ stripUnknown: true });
